import { useMemo } from 'react'
import {
	getApplyOnLabel,
	getApplicationPortal,
} from 'shared/utils/applicationPortal'
import { getIntake, mapRequirements } from '../../../utils/applicationDetailsFormat'

export const useRequirements = ({
	application,
	headerInfo,
	requirementsData,
	applicationStatusHeading,
}) => {
	const requirements = useMemo(
		() => mapRequirements(application, requirementsData, headerInfo),
		[application, requirementsData, headerInfo],
	)

	const applyOn = useMemo(() => getApplyOnLabel(application), [application])

	const intake = useMemo(
		() => getIntake(application, headerInfo),
		[application, headerInfo],
	)

	const portal = useMemo(
		() => getApplicationPortal(application),
		[application],
	)

	return {
		requirements,
		applyOn,
		intake,
		portal,
		applicationStatusHeading,
	}
}
